import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {useRampFlagMultiNodeLogs} from '../../util/rampFeatureFlags';
import {Banner} from '../Banner';

export const LogLabelsBanner = () => {
  const isMultiNodeLogFilteringEnabled = useRampFlagMultiNodeLogs();
  if (!isMultiNodeLogFilteringEnabled) {
    return null;
  }

  return (
    <Banner variant="info" className="mb-16">
      <div className="flex gap-16">
        <Icon name="lightbulb-info" />
        <span>
          <span className="font-semibold">Hardware labels found.</span> Logging
          for this run will be broken out by hardware labels.
        </span>
      </div>
      {/* TODO: WB-24052 add learn more link once docs are available */}
    </Banner>
  );
};
